/** Reserved height for fixed HeaderV2 (matches AppBar content + padding). */
export const V2_HEADER_HEIGHT = {
  xs: 68,
  md: 76,
};

/** Spacer below fixed header — render once after HeaderV2. */
export const v2HeaderSpacerSx = {
  height: V2_HEADER_HEIGHT,
  flexShrink: 0,
};

/** Sticky panels (e.g. package filters) sit below header + small gap. */
export const v2StickyBelowHeaderTop = {
  xs: V2_HEADER_HEIGHT.xs + 12,
  md: V2_HEADER_HEIGHT.md + 16,
};
